import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Link from "next/link";

import { useI18n } from "@/i18n/I18nProvider";

import LanguageToggle from "./LanguageToggle";
import { mobileBar, mobileOnly } from "./navbar.styles";

/* The single compact bar shown below 900px: drawer trigger, logo, language. */
export default function MobileBar({ onOpenDrawer }) {
  const { t } = useI18n();

  return (
    <Box
      className="horizontal-safe-padding"
      sx={{ ...mobileBar.container, ...mobileOnly }}
    >
      <IconButton
        aria-label="Toggle menu"
        onClick={onOpenDrawer}
        sx={mobileBar.menuButton}
      >
        <MenuIcon />
      </IconButton>

      <Box component={Link} href="/">
        <Box
          component="img"
          src={t.logo}
          alt="Contact"
          height="22px"
          width="80px"
          loading="lazy"
        />
      </Box>

      <LanguageToggle sx={mobileBar.languageButton} />
    </Box>
  );
}
